var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5898 13.4819L16.1077 17.1247L17.6255 13.4819",
    stroke: "#343435",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10709 16.7073C8.81662 16.9729 8.43816 17.1215 8.04461 17.1247C7.11874 17.1247 6.375 16.3127 6.375 15.3033C6.375 14.294 7.11874 13.4819 8.04461 13.4819C8.43816 13.4851 8.81662 13.6338 9.10709 13.8993",
    stroke: "#343435",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7859 16.8214C11.1148 17.0667 11.5139 17.1997 11.9243 17.2008C12.6073 17.2008 13.2144 16.9731 13.2144 16.2142C13.2144 15 10.7859 15.5312 10.7859 14.3928C10.7859 13.7857 11.2412 13.4062 11.9243 13.4062C12.3346 13.4073 12.7337 13.5404 13.0626 13.7857",
    stroke: "#343435",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H14.25L19.5 8.25V12",
    stroke: "#343435",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 21.75C4.85217 21.75 4.47064 21.592 4.18934 21.3107C3.90804 21.0294 3.75 20.6478 3.75 20.25V12C3.75 11.5858 4.08579 11.25 4.5 11.25C4.91421 11.25 5.25 11.5858 5.25 12L5.25 20.25H9.75H14.25H18.75V12C18.75 11.5858 19.0858 11.25 19.5 11.25C19.9142 11.25 20.25 11.5858 20.25 12V20.25C20.25 20.6478 20.092 21.0294 19.8107 21.3107C19.5294 21.592 19.1478 21.75 18.75 21.75H14.25H9.75H5.25Z",
    fill: "#343435"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3V8.25H19.5",
    stroke: "#343435",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/CSVIcon.2df4a0382ab948ded06335bb0fce104e.svg";
export { ForwardRef as ReactComponent };